import { useCallback, useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { Section } from 'constants/section';
import { getItem, saveItem } from 'services/local-storage';
import { getCurrentSection } from 'store/features/routing/selectors';

const TOOLTIP_SEEN_KEY = 'move-to-text-tooltip-seen';
const TOOLTIP_DELAY_MS = 1500;

interface MoveToTextTooltipState {
  isTooltipVisible: boolean;
  dismissTooltip: () => void;
}

export function useMoveToTextTooltip(isEligible: boolean): MoveToTextTooltipState {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const isPageOpen = useSelector(getCurrentSection) === Section.MoveToText;

  useEffect(() => {
    if (isPageOpen) {
      setIsTooltipVisible(false);

      return;
    }

    if (!isEligible || getItem(TOOLTIP_SEEN_KEY)) {
      return;
    }

    const timeout = window.setTimeout(() => {
      setIsTooltipVisible(true);
      saveItem(TOOLTIP_SEEN_KEY, true);
    }, TOOLTIP_DELAY_MS);

    return () => window.clearTimeout(timeout);
  }, [isEligible, isPageOpen]);

  const dismissTooltip = useCallback(() => setIsTooltipVisible(false), []);

  return { isTooltipVisible, dismissTooltip };
}
